import { AssetRequest } from '@atom/types/assetRequest';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

export type ADOTViewer = {
  userId: string;
  userGroupIds: string[];
};

export const canCreateADOTRequest = (): boolean =>
  hasRolePermissions(ROLE_SETS.INSPECTOR);

export const canCancelADOTTransfer = (
  request: AssetRequest,
  viewer: ADOTViewer,
): boolean =>
  hasRolePermissions(ROLE_SETS.ORG_ADMIN) ||
  (hasRolePermissions(ROLE_SETS.INSPECTOR) &&
    request?.createdBy?.id === viewer.userId);

export const canApproveOrRejectADOTTransfer = (
  request: AssetRequest,
  viewer: ADOTViewer,
): boolean => {
  if (hasRolePermissions(ROLE_SETS.ORG_ADMIN)) {
    return true;
  }

  const isAssignedUser = (request?.assignedTo || []).some(
    user => user?.id === viewer.userId,
  );

  const isAssignedGroupMember = (request?.assignedToGroups || []).some(group =>
    viewer.userGroupIds.includes(group?.id),
  );

  return (
    hasRolePermissions(ROLE_SETS.INSPECTOR) &&
    (isAssignedUser || isAssignedGroupMember)
  );
};

export const canEditADOTReplenishment = (): boolean =>
  hasRolePermissions(ROLE_SETS.ORG_ADMIN);
